import { gql } from '@apollo/client';

const SEND_RESET_PASSWORD = gql`
  mutation sendResetPassword($input: SendResetPasswordInput!) {
    sendResetPassword(input: $input)
  }
`;

export default SEND_RESET_PASSWORD;
